import SectionOccupationsProvider from '../../../providers/SectionOccupationsProvider'

var SectionOccupationsService = function () {
  return {
    async getSectionOccupations (objectId, token, dtFrom, dtTo) {
      return SectionOccupationsProvider.getSectionOccupations(objectId, token, dtFrom, dtTo)
    },
    async getReference (objectId, token, dtFrom, dtTo) {
      return SectionOccupationsProvider.getReference(objectId, token, dtFrom, dtTo)
    },
    async getOccupiedDatas (objectId, token, dtFrom, dtTo) {
      return SectionOccupationsProvider.getOccupiedDatas(objectId, token, dtFrom, dtTo)
    }
  }
}

export default new SectionOccupationsService()



// WEBPACK FOOTER //
// ./src/services/api/axleshunt/SectionOccupationsService.js